import { useMutation } from '@apollo/client';
import createMessageGQL from '../public_site/createContactMessage.graphql';

export const useCreateContactMessage = (options = {}) => {
  return useMutation(createMessageGQL, {
    ...options
  });
};
